import {
    getSubFloorManholeMinOverlap,
} from "./lid";
import {getVaultSize} from "./vault";
import {Plan, Manhole} from "../../types";
import {ElementSize} from "./elementSize";


export const getIntermediateCeilingSize = (plan: Plan): ElementSize =>  {
    if (!plan.intermediateCeiling) {
        return {width: 0, length: 0, height: 0, x: 0, y: 0}
    }
    return {
        width: plan.width + 2 * plan.wallWidth,
        length: plan.length + 2 * plan.wallWidth,
        height: 25,
        x: -plan.wallWidth,
        y: -plan.wallWidth
    }
}

export const getManholeClearMeasure = (plan: Plan, manhole: Manhole) => {
    const vaultSize = getVaultSize(plan, true)
    const getXWithinVaultClearMeasure = (x: number) => {
        return Math.max(
            vaultSize.clearMeasureLeft,
            Math.min(vaultSize.clearMeasureRight, x)
        )
    }
    const getYWithinVaultClearMeasure = (y: number) => {
        return Math.max(
            vaultSize.clearMeasureFront,
            Math.min(vaultSize.clearMeasureBack, y)
        )
    }
    const getRectWithinVaultClearMeasure = (rect: any) => {
        const getLeft = () => getXWithinVaultClearMeasure(rect.x)
        const getRight = () => getXWithinVaultClearMeasure(rect.x + rect.width)
        const getBottom = () => getYWithinVaultClearMeasure(rect.y)
        const getTop = () => getYWithinVaultClearMeasure(rect.y + rect.height)

        return {
            x: getLeft(),
            y: getBottom(),
            width: getRight() - getLeft(),
            height: getTop() - getBottom()
        }
    }
    const getSubFloorManholeClearMeasure = (plan: Plan, manhole: Manhole) => {
        const getMinOverlapApplied = (manhole: Manhole) => {
            return manhole.orientation === 'vertical'
                ? {
                    x: manhole.x,
                    y: manhole.y + getSubFloorManholeMinOverlap(),
                    width: manhole.width,
                    height: manhole.height - 2 * getSubFloorManholeMinOverlap()
                }
                : {
                    x: manhole.x + getSubFloorManholeMinOverlap(),
                    y: manhole.y,
                    width: manhole.width - 2 * getSubFloorManholeMinOverlap(),
                    height: manhole.height
                }
        }

        return getRectWithinVaultClearMeasure(getMinOverlapApplied(manhole))
    }

    return plan.lid.type === 'subfloor'
        ? getSubFloorManholeClearMeasure(plan, manhole)
        : getRectWithinVaultClearMeasure(manhole)
}


